function encodeBase64(data) {
    const codeUnits16 = new Uint16Array(data.length).map((_, i)=>data.charCodeAt(i));
    const codeUnits8 = String.fromCharCode(...new Uint8Array(codeUnits16.buffer));
    return btoa(codeUnits8);
}
function decodeBase64(value) {
    const decoded = atob(value);
    const codeUnits8 = new Uint8Array(decoded.length).map((_, i)=>decoded.charCodeAt(i));
    return String.fromCharCode(...new Uint16Array(codeUnits8.buffer));
}
export { decodeBase64, encodeBase64 };
